import HrPeopleTable from 'components/tables/data/hr/HrPeopleTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/** Route-level layout for the HR people table. */
export default function HrPeoplePage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Osoby' }]}>
      <HrPeopleTable />
    </DashboardLayout>
  );
}
